<template>
  <div class="myPrize-container">
    <van-nav-bar title="我的奖品">
      <template #left>
        <img
          class="leftImg"
          @click="$router.push('/activeWheel')"
          src="@/assets/jiantou@2x.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="content-box">
      <div class="contentBgc">
        <van-cell-group>
          <van-list
            v-model="loading"
            :offset="10"
            :finished="finished"
            :finished-text="finishedText"
            @load="onload"
          >
            <!-- 空状态 -->
            <div class="nullbox" v-if="prizelist.length == 0">
              <img
                class="nullImg"
                src="@/assets/zpqietu/macaroni@2x.png"
                alt=""
              />
              <h6>您暂时还没有奖品哦~</h6>
            </div>
            <!-- 中奖状态 -->
            <ul v-else>
              <li v-for="(item, index) in prizelist" :key="index">
                <div class="leftbox">
                  <img class="gift" :src="url + item.imgurl" alt="" />
                </div>
                <div class="rightbox">
                  <p v-show="item.type == 1">
                    金额：<span>{{ item.amountStr }}<em>元</em></span>
                  </p>
                  <p v-show="item.type == 2">
                    {{ item.title }}
                  </p>
                  <strong>{{ item.createDate }} 获得</strong>
                </div>
              </li>
            </ul>
          </van-list>
        </van-cell-group>
      </div>
      <div class="botbox">
        <img class="botImg" src="@/assets/zpqietu/jptp@2x.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { getUserPrize } from "@/api/new";
import Common from "@/components/comm";

export default {
  name: "myPrize",
  components: {},
  props: {},
  data() {
    return {
      url: Common.getUrl(),
      prizelist: [],
      queryInfo: {
        pageNo: 0,
        pageSize: 10,
      },
      type: "", //奖品类型(1红包2实物9谢谢)
      loading: false, //上拉加载
      finished: false, //上拉加载完毕
      finishedText: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.onload();
  },
  mounted() {},
  methods: {
    async getUserPrizes() {
      this.loading = true;
      const { data: res } = await getUserPrize(
        this.$qs.stringify(this.queryInfo)
      );
      this.type = res.data.type;
      this.loading = false;
      if (res.data.userPrizeList.length < 10) {
        // this.finishedText = "暂无数据 ";
        this.finished = true; //上拉加载完毕
      } else {
        this.finished = false;
      }
      if (res.data.userPrizeList) {
        this.prizelist = this.prizelist.concat(res.data.userPrizeList);
      } else {
        this.prizelist = [];
      }
    },
    onload() {
      this.queryInfo.pageNo++;
      this.getUserPrizes();
    },
  },
};
</script>

<style scoped lang="less">
.content-box {
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 92px);
  background: url("../../assets/zpqietu/hsde@2x.png") no-repeat center center;
  background-size: cover;
  overflow: auto;
}
.leftImg {
  width: 27px;
  height: 44px;
}
.contentBgc {
  width: 690px;
  height: 1056px;
  border: 5px solid #ffc028;
  border-radius: 16px;
  background: #ffefd9;
  margin: 30px;
  overflow-y: scroll;
  box-shadow: 0 0 0 2px inset #ffc028;
}
.botImg {
  width: 100%;
  height: 174px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
ul {
  margin: 30px 0;
}
li {
  display: flex;
  margin: 20px 30px;
}
.leftbox {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  height: 182px;
  background: #ffd97e;
  border-radius: 14px 0px 0px 14px;
}
.gift {
  width: 104px;
  height: 104px;
  margin: 0 auto;
}
.rightbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 70%;
  padding: 0 30px;
  background: #ffffff;
  border-radius: 0px 14px 14px 0px;
}
p {
  font-size: 28px;
  font-weight: 500;
  color: #241500;
}
span {
  font-size: 36px;
  font-weight: bold;
  color: #d31b1c;
}
em {
  font-size: 20px;
  font-style: normal;
}
strong {
  font-size: 24px;
  font-weight: 500;
  color: #b4b4b4;
  margin-top: 20px;
}
.nullbox {
  margin: 180px 200px;
}
.nullImg {
  width: 267px;
  height: 191px;
}
h6 {
  font-size: 28px;
  font-weight: 500;
  color: #d31b1c;
}
.van-cell-group {
  background-color: transparent;
}
</style>